<template>
  <div class="header">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      title: process.env.VUE_APP_SITE_TITLE,
    };
  },
};
</script>

<style scoped>
.header {
  padding: var(--unit-extra-large);
}
</style>
